document.addEventListener('DOMContentLoaded', function() {
  'use strict';
  
  const carousels = document.querySelectorAll('.loox-reviews-carousel:not([data-flickity-initialized])');
  if (!carousels.length || typeof Flickity === 'undefined') return;

  carousels.forEach((carousel) => {
    const prevButton = carousel.querySelector('.flickity-prev');
    const nextButton = carousel.querySelector('.flickity-next');
    const hasCustomArrows = !!(prevButton && nextButton);

    const flkty = new Flickity(carousel, {
      wrapAround: false,
      cellAlign: 'left',
      pageDots: false,
      contain: true,
      prevNextButtons: !hasCustomArrows,
      cellSelector: '.carousel__slide',
      adaptiveHeight: false
    });

    carousel.classList.remove('visibility-hidden');

    const getAllSlides = carousel.querySelectorAll('.carousel__slide');
    getAllSlides && getAllSlides.forEach((slide) => {
      slide.style.height = '100%';
    });

    if (hasCustomArrows) {
      function updateButtons() {
        const isFirst = flkty.selectedIndex === 0;
        const isLast = flkty.selectedIndex === flkty.slides.length - 1;

        [prevButton, nextButton].forEach((btn, index) => {
          if (!btn) return;
          const isDisabled = index === 0 ? isFirst : isLast;
          btn.style.opacity = isDisabled ? '0.4' : '1';
          btn.style.cursor = isDisabled ? 'not-allowed' : 'pointer';
        });
      }

      prevButton?.addEventListener('click', () => {
        if (flkty.selectedIndex > 0) flkty.previous();
      });

      nextButton?.addEventListener('click', () => {
        if (flkty.selectedIndex < flkty.slides.length - 1) flkty.next();
      });

      updateButtons();
      flkty.on('change', updateButtons);
    }

    carousel.setAttribute('data-flickity-initialized', 'true');
  });
});
